module.exports = "../../../../platform/assets/pageMainIcon/youth_baobiaochaxunlei6.svg";